<div id="activity-test-loading" *ngIf="loading">
    <i class="fas fa-spinner fa-spin"></i>
    <span *ngIf="type == 'activity'">Cargando actividades...</span>
    <span *ngIf="type == 'test'">Cargando evaluación...</span>
</div>

<div id="activity-test-error" *ngIf="!loading && error" class="text-danger">
    <i class="fa fa-times"></i>
    <span>Error</span>
</div>

<div id="activity-test" *ngIf="!loading && !error" class="me-3">

    <h1 id="activity-test-title" class="mb-3" *ngIf="title">
        {{ title }}
    </h1>

    <div id="activity-test-errors" class="alert alert-danger" *ngIf="errors.length > 0">
        <p>Se han encontrado los siguientes errores:</p>
        <ul>
            <li *ngFor="let error of errors">
                {{ error }}
            </li>
        </ul>
    </div>
    
    <div id="activity-test-items-empty" *ngIf="questions.length === 0">
        <p>No hay preguntas.</p>
    </div>
    
    <table id="activity-test-items-table" class="table mb-3" *ngIf="questions.length > 0">
        <thead>
            <tr class="text-center">
                <th class="fw-bold">Pregunta</th>
                <th class="fw-bold">Tipo Respuesta</th>
                <th class="fw-bold">Opciones / Solución</th>
                <th class="fw-bold">Acciones</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let question of questions; let q = index;">
                <td>
                    <span title="Haz clic para editar la pregunta" (click)="showEdit($event)">{{ question.sentence }}</span>
                    <textarea type="text" class="d-none" cols="45" rows="5" title="Presiona Enter para guardar los cambios, Esc para cancelar" (keydown.esc)="hideEdit($event)" (keydown.enter)="editQuestionSentence($event, q)" value="{{ question.sentence }}"></textarea>
                </td>
                <td>
                    <select [(ngModel)]="question.type" (ngModelChange)="editQuestionType($event, q)">
                        <option value="single">Única</option>
                        <option value="multiple">Múltiple</option>
                        <option value="open">Abierta</option>
                        <option value="dictation">Dictado</option>
                    </select>
                </td>
                <td>
                    <!-- Si es opción única o múltiple -->
                    <div *ngIf="question.type == 'single' || question.type == 'multiple'">
                        <div class="text-center mb-3" *ngFor="let option of question.options; let o = index;">
                            <input *ngIf="question.type == 'single'" type="radio" class="me-2" title="Selecciona una opción para cambiar la respuesta, dejar en blanco para eliminar" name="question_{{ question.id }}" value="{{ option }}" [attr.checked]="question.solution === option ? 'checked' : null" (change)="editQuestionSolution($event, question.id, q)">
    
                            <input *ngIf="question.type == 'multiple'" type="checkbox" class="me-2" title="Selecciona una opción para cambiar la respuesta, dejar en blanco para eliminar" name="question_{{ question.id }}" value="{{ option }}" [attr.checked]="question.solution.includes(option) ? 'checked' : null" (change)="editQuestionSolution($event, question.id, q)">
    
                            <span title="Haz clic en las opciones para editarlas" (click)="showEdit($event)">{{ option }}</span>
    
                            <input type="text" class="d-none" title="Presiona Enter para guardar los cambios, Esc para cancelar, borra el texto y pulsa Enter para eliminar" value="{{ option }}" (keydown)="handleInput($event, q, o)">
                            
                            <a href="#" class="red ms-2" title="Eliminar" (click)="removeOption(q, o)">
                                <i class="fas fa-times text-danger"></i>
                            </a>
                        </div>
                        <button class="btn btn-primary" (click)="addOption(q)">
                            <i class="fas fa-plus"></i>
                            <span>Nueva opción</span>
                        </button>
                    </div>

                    <!-- Si es opción abierta -->
                    <div *ngIf="question.type == 'open'">
                        <input type="text" class="form-control me-2" name="question_{{ question.id }}" value="{{ question.solution }}">
                        <button class="btn btn-success d-block mx-auto my-3" (click)="editQuestionSolution($event, question.id, q)">
                            <i class="fas fa-save"></i>
                            <span>Guardar</span>
                        </button>
                        <div class="text-success d-none">
                            <i class="fas fa-check"></i>
                            <span>¡Guardado!</span>
                        </div>
                    </div>

                    <!-- Si es opción dictado -->
                    <div *ngIf="question.type == 'dictation'">
                        <div class="mb-3">
                            <p class="fw-bold">Texto:</p>
                            <textarea class="form-control me-2" name="question_{{ question.id }}" value="{{ question.solution }}" style="height: 200px;"></textarea>
                        </div>
                        <button class="btn btn-success d-block mx-auto my-3" (click)="editQuestionSolution($event, question.id, q)">
                            <i class="fas fa-save"></i>
                            <span>Guardar</span>
                        </button>
                        <div class="text-success d-none">
                            <i class="fas fa-check"></i>
                            <span>¡Guardado!</span>
                        </div>
                        <hr>
                        <div class="mb-3">
                            <p class="fw-bold">Audio:</p>
                            <div *ngIf="question.audio != null">
                                <audio controls>
                                    <source src="http://brainscorm.vl28655.dinaserver.com/media/aud/{{ course }}/{{ question.audio }}" type="audio/mp3">
                                </audio>
                            </div>
                            <div *ngIf="question.audio == null">
                                <span>No se ha subido ningún audio.</span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <p class="fw-bold">Subir audio nuevo:</p>
                            <input type="file" (change)="uploadAudio($event, question.id, q)">
                        </div>
                    </div>
                </td>
                <td>
                    <a href="#" class="me-2" title="Mover hacia arriba" (click)="moveQuestion(q, 'up')" *ngIf="questions.length > 1">
                        <i class="fas fa-arrow-up"></i>
                    </a>
                    <a href="#" class="me-2" title="Mover hacia abajo" (click)="moveQuestion(q, 'down')" *ngIf="questions.length > 1">
                        <i class="fas fa-arrow-down"></i>
                    </a>
                    <a href="#" class="red me-2" title="Eliminar" (click)="deleteQuestion(q)">
                        <i class="fas fa-times text-danger"></i>
                    </a>
                </td>
            </tr>
        </tbody>
    </table>

    <button class="btn btn-success me-3" (click)="addQuestion()">
        <i class="fas fa-plus"></i>
        <span>Añadir pregunta</span>
    </button>

    <hr>

    <button id="activity-test-criteria-btn" class="btn btn-primary" (click)="showCriteria = !showCriteria">
        <div *ngIf="!showCriteria">
            <i class="fas fa-eye"></i>
            <span>Mostrar criterios asociados</span>
        </div>
        <div *ngIf="showCriteria">
            <i class="fas fa-eye-slash"></i>
            <span>Ocultar criterios asociados</span>
        </div>
    </button>
    
    <div id="activity-test-criteria-container" class="mt-3" *ngIf="showCriteria">
        <p class="fw-bold">Criterios asociados:</p>
        <ul id="activity-test-criteria" class="me-3">
            <li *ngFor="let crit of criteria">
                <label>
                    <input type="checkbox" class="me-2" name="activity_test_{{ id }}_criteria" id="activity_test_{{ id }}_criteria_{{ crit.id }}" [value]="crit.id" [checked]="selectedCriteria.includes(crit.id)" (change)="checkCriteria($event)">
                    <span class="fw-bold me-1">{{ crit.code }}:</span>
                    <span>{{ crit.content }}</span>
                </label>
            </li>
        </ul>
    </div>

    <div id="review-heading-container" *ngIf="type == 'test'">
        <hr>

        <button id="review-heading-btn" class="btn btn-primary" (click)="showReviewHeading = !showReviewHeading">
            <div *ngIf="!showReviewHeading">
                <i class="fas fa-eye"></i>
                <span>Mostrar enunciado de repaso</span>
            </div>
            <div *ngIf="showReviewHeading">
                <i class="fas fa-eye-slash"></i>
                <span>Ocultar enunciado de repaso</span>
            </div>
        </button>
    
        <div id="review-heading-select-container" class="mt-3" *ngIf="showReviewHeading">
            <p class="fw-bold">Enunciado de repaso:</p>
            <select name="review-heading-select" id="review-heading-select" class="me-3" [(ngModel)]="selectedReviewHeading" (ngModelChange)="saveActivityTestReviewHeading(id, selectedReviewHeading)">
                <option selected value="0">Ninguno</option>
                <option *ngFor="let heading of reviewHeadings" [value]="heading.id">
                    {{ heading.name }}
                </option>
            </select>
        </div>
    </div>

</div>